import NewsletterError from './NewsletterErrorDetails';
export const NewsletterErrorDetails = NewsletterError;